import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    details: string;
    cancel: string;
    confirmationInstructions: (confirmationWord: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Details for the confirmation dialog when switching to standard storage */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DisableMountedStorageDialog.details?c=7yo3hdgagpyc", defaultMessage: "This project will switch to Standard Storage. Members who currently have it mounted can continue until they unmount, but no new mounts will be allowed." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the cancel button in the confirmation dialog */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "DisableMountedStorageDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Instruction prompting the user to type the confirmation text to proceed */
            confirmationInstructions: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (confirmationWord: string) => __intl__.intl().formatMessage({ id: "DisableMountedStorageDialog.confirmationInstructions?c=2mzfvu0d48hje", defaultMessage: "Type \"{var}\" to confirm" }, { var: confirmationWord.toLowerCase() }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
